import { ChatMessage, ChatMessagePart } from 'types/Chat'

const getChatMessageParts = (message: ChatMessage): ChatMessagePart[] => [
  { type: 'text', text: message.content },
]

export { getChatMessageParts }
